<template>
  <footer 
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
    class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a 
              href="mailto:info@AirportParking.club">
              Contact Us
            </a>
          </li>
          <li>
            <router-link 
              to="/terms-of-service">
              Terms of Service
            </router-link>
          </li>
          <li>
            <router-link 
              to="/privacy-policy">
              Privacy Policy
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        Airport Parking Club &copy; {{ year }}
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
